import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/hrms`;

const api = axios.create({ baseURL: BASE, timeout: 25000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('hrms_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const hrmsLogin = (email, password) => api.post('/auth/login', { email, password }).then(r => r.data);
export const hrmsMe = () => api.get('/auth/me').then(r => r.data);
export const hrmsResetPassword = (new_password) => api.post('/auth/reset-password', { new_password }).then(r => r.data);
export const hrmsStats = () => api.get('/stats').then(r => r.data);

export const hrmsListJobs = () => api.get('/jobs').then(r => r.data);
export const hrmsCreateJob = (body) => api.post('/jobs', body).then(r => r.data);
export const hrmsUpdateJob = (id, patch) => api.patch(`/jobs/${id}`, patch).then(r => r.data);
export const hrmsDeleteJob = (id) => api.delete(`/jobs/${id}`).then(r => r.data);

export const hrmsListApplications = (params) => api.get('/applications', { params }).then(r => r.data);
export const hrmsMoveStage = (aid, stage, note) => api.patch(`/applications/${aid}/stage`, { stage, note }).then(r => r.data);
export const hrmsListCandidates = () => api.get('/candidates').then(r => r.data);
export const hrmsListNotifs = () => api.get('/notifications').then(r => r.data);

// -------- Google Auth --------
export const hrmsGoogleAuth = (session_id) => api.post('/auth/google', { session_id }).then(r => r.data);

// -------- Interviews (Phase 2) --------
export const hrmsListInterviews = (params) => api.get('/interviews', { params }).then(r => r.data);
export const hrmsCreateInterview = (body) => api.post('/interviews', body).then(r => r.data);
export const hrmsUpdateInterview = (iid, patch) => api.patch(`/interviews/${iid}`, patch).then(r => r.data);
export const hrmsCancelInterview = (iid) => api.delete(`/interviews/${iid}`).then(r => r.data);

// -------- Offers (Phase 3) --------
export const hrmsListOffers = (params) => api.get('/offers', { params }).then(r => r.data);
export const hrmsCreateOffer = (body) => api.post('/offers', body).then(r => r.data);
export const hrmsGetOffer = (oid) => api.get(`/offers/${oid}`).then(r => r.data);
export const hrmsSendOffer = (oid) => api.post(`/offers/${oid}/send`).then(r => r.data);
export const hrmsRevokeOffer = (oid) => api.post(`/offers/${oid}/revoke`).then(r => r.data);

// -------- Public offer (candidate view) --------
const pubOffer = axios.create({ baseURL: BASE, timeout: 25000 });
export const publicGetOffer = (token) => pubOffer.get(`/public/offers/${token}`).then(r => r.data);
export const publicDecideOffer = (token, decision, reason) => pubOffer.post(`/public/offers/${token}/decision`, { decision, reason }).then(r => r.data);

// -------- Employees (Phase 4) --------
export const hrmsListEmployees = () => api.get('/employees').then(r => r.data);
export const hrmsCreateEmployee = (body) => api.post('/employees', body).then(r => r.data);
export const hrmsUpdateEmployee = (eid, patch) => api.patch(`/employees/${eid}`, patch).then(r => r.data);
export const hrmsGetEmployee = (eid) => api.get(`/employees/${eid}`).then(r => r.data);

// Self-service
export const hrmsMyProfile = () => api.get('/me/profile').then(r => r.data);
export const hrmsMyLeaves = () => api.get('/me/leaves').then(r => r.data);
export const hrmsRequestLeave = (body) => api.post('/me/leaves', body).then(r => r.data);

// Admin leaves
export const hrmsAllLeaves = (params) => api.get('/leaves', { params }).then(r => r.data);
export const hrmsDecideLeave = (lid, status, comment) => api.patch(`/leaves/${lid}`, { status, comment }).then(r => r.data);

// -------- Attendance (Phase 5) --------
export const hrmsClockIn = (note = '') => api.post('/me/attendance/clock-in', { note }).then(r => r.data);
export const hrmsClockOut = (note = '') => api.post('/me/attendance/clock-out', { note }).then(r => r.data);
export const hrmsMyAttendance = (month) => api.get('/me/attendance', { params: month ? { month } : {} }).then(r => r.data);
export const hrmsAllAttendance = (params) => api.get('/attendance', { params }).then(r => r.data);
export const hrmsCorrectAttendance = (body) => api.post('/attendance/correct', body).then(r => r.data);

// -------- Payroll (Phase 5) --------
export const hrmsRunPayroll = (body) => api.post('/payroll/run', body).then(r => r.data);
export const hrmsListPayroll = (params) => api.get('/payroll', { params }).then(r => r.data);
export const hrmsMyPayslips = () => api.get('/me/payslips').then(r => r.data);

// -------- Analytics (Phase 5) --------
export const hrmsAnalyticsOverview = () => api.get('/analytics/overview').then(r => r.data);
export const hrmsAnalyticsFunnel = (job_id) => api.get('/analytics/funnel', { params: job_id ? { job_id } : {} }).then(r => r.data);
export const hrmsAnalyticsTat = () => api.get('/analytics/tat').then(r => r.data);
export const hrmsAnalyticsSources = () => api.get('/analytics/sources').then(r => r.data);
export const hrmsAnalyticsOffers = () => api.get('/analytics/offers').then(r => r.data);

// -------- Signed offer --------
export const hrmsOfferSignature = (oid) => api.get(`/offers/${oid}/signature`).then(r => r.data);

// -------- Payroll email + Attendance nudge --------
export const hrmsEmailPayslip = (pid) => api.post(`/payroll/${pid}/email`).then(r => r.data);
export const hrmsNudgeAttendance = () => api.post('/attendance/nudge').then(r => r.data);

// -------- Bulk payroll job (Phase 7) --------
export const hrmsBulkEmailPayslips = (body) => api.post('/payroll/email-all', body).then(r => r.data);
export const hrmsGetJob = (jid) => api.get(`/jobs/${jid}`).then(r => r.data);
export const hrmsListBgJobs = (params) => api.get('/jobs', { params }).then(r => r.data);

// -------- Referrals (Phase 7) --------
export const hrmsMyReferralLink = () => api.get('/me/referral-link').then(r => r.data);
export const hrmsMyReferrals = () => api.get('/me/referrals').then(r => r.data);
export const hrmsAllReferrals = () => api.get('/referrals').then(r => r.data);

// -------- Calendar (Phase 7) --------
export const hrmsCalendarWeek = (start) => api.get('/calendar/week', { params: { start } }).then(r => r.data);

// -------- Google Calendar integration --------
export const gcalStatus = () => api.get('/integrations/google/status').then(r => r.data);
export const gcalConnect = () => api.get('/integrations/google/connect').then(r => r.data);
export const gcalDisconnect = () => api.post('/integrations/google/disconnect').then(r => r.data);

// -------- Slack integration --------
export const slackStatus = () => api.get('/integrations/slack/status').then(r => r.data);
export const slackTest = (kind) => api.post(`/integrations/slack/test/${kind}`).then(r => r.data);

// -------- Onboarding kit (Phase 8) --------
export const hrmsMyOnboarding = () => api.get('/me/onboarding').then(r => r.data);
export const hrmsToggleOnboardingTask = (task_id, completed) => api.patch('/me/onboarding/tasks', { task_id, completed }).then(r => r.data);
export const hrmsUploadOnboardingDoc = (body) => api.post('/me/onboarding/documents', body).then(r => r.data);
export const hrmsDownloadMyOnboardingDoc = (doc_id) => api.get(`/me/onboarding/documents/${doc_id}`).then(r => r.data);
export const hrmsListOnboarding = () => api.get('/onboarding').then(r => r.data);
export const hrmsGetOnboarding = (oid) => api.get(`/onboarding/${oid}`).then(r => r.data);
export const hrmsAdminDownloadDoc = (oid, doc_id) => api.get(`/onboarding/${oid}/documents/${doc_id}`).then(r => r.data);
export const hrmsUpdateOnboardingAdmin = (oid, body) => api.patch(`/onboarding/${oid}`, body).then(r => r.data);
export const hrmsAssignBuddy = (oid) => api.post(`/onboarding/${oid}/assign-buddy`).then(r => r.data);

// -------- AI Screening (Phase 9) --------
export const hrmsScoreOne = (app_id) => api.post(`/applications/${app_id}/score`).then(r => r.data);
export const hrmsScoreAll = (job_id) => api.post('/applications/score-all', null, { params: job_id ? { job_id } : {} }).then(r => r.data);
export const hrmsRouteTop = (body) => api.post('/applications/route-top', body).then(r => r.data);

// -------- Handbook (Phase 9) --------
export const hrmsGetHandbook = () => api.get('/handbook').then(r => r.data);
export const hrmsSaveHandbook = (body) => api.put('/handbook', body).then(r => r.data);
export const hrmsResetHandbook = () => api.post('/handbook/reset').then(r => r.data);
export const hrmsAcknowledgeHandbook = () => api.post('/me/handbook/acknowledge').then(r => r.data);

// -------- Phase 10 --------
export const hrmsSummarizeInterview = (iid, notes) => api.post(`/interviews/${iid}/summarize`, { notes }).then(r => r.data);
export const hrmsSendJoinerDigest = () => api.post('/onboarding/digest/send-now').then(r => r.data);

// Public
const pub = axios.create({ baseURL: BASE, timeout: 25000 });
export const publicJobs = () => pub.get('/public/jobs').then(r => r.data);
export const publicJobDetail = (jid) => pub.get(`/public/jobs/${jid}`).then(r => r.data);
export const publicApply = (jid, body, ref) => pub.post(`/public/apply/${jid}`, body, { params: ref ? { ref } : {} }).then(r => r.data);
export const applyProfile = () => pub.get('/public/apply-profile', { withCredentials: true }).then(r => r.data);
export const oneClickApply = (jid, ref) => pub.post(`/public/one-click-apply/${jid}`, {}, { params: ref ? { ref } : {}, withCredentials: true, headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.data);

export const PIPELINE_STAGES = [
  'applied', 'screening', 'shortlisted', 'interview_scheduled',
  'interview_completed', 'selected', 'offer_sent', 'offer_accepted',
  'offer_rejected', 'joined', 'rejected',
];

export const STAGE_LABEL = {
  applied: 'Applied', screening: 'Screening', shortlisted: 'Shortlisted',
  interview_scheduled: 'Interview Scheduled', interview_completed: 'Interview Completed',
  selected: 'Selected', offer_sent: 'Offer Sent', offer_accepted: 'Offer Accepted',
  offer_rejected: 'Offer Rejected', joined: 'Joined', rejected: 'Rejected',
};
